/**
 * Fantasy Console 0 - Supabase Client
 *
 * Provides the Supabase client instance for cloud storage operations.
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Missing Supabase environment variables. Cloud storage features will be disabled.',
  )
}

/**
 * Supabase client instance
 * May be null if environment variables are not configured
 */
export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null

/**
 * Check if Supabase is configured and available
 */
export function isSupabaseConfigured(): boolean {
  return supabase !== null
}

/**
 * Database cart row type (matches Supabase schema)
 */
export interface DbCart {
  id: string
  version: number | null
  user_id: string
  title: string
  author: string | null
  description: string | null
  code_files: { name: string; content: string }[]
  sprites: string | null // base64 encoded
  map: string | null // base64 encoded
  sfx: string | null // base64 encoded
  thumbnail_url: string | null
  forked_from: string | null
  created_at: string
  updated_at: string
}

/**
 * Cart with stats from the carts_with_stats view
 */
export interface DbCartWithStats extends DbCart {
  username: string | null
  like_count: number
  is_liked_by_current_user: boolean
}
